import { Formik, Form } from 'formik'
import { Fragment, useState } from 'react'
import Fields from '@components/fields'
import Column from '@components/column'
import Row from '@components/row'
import Button from '@components/button'
import {
  StyleGrid,
  StyleGridItem,
  styleDocumentUploadWrapper,
  styleCircle,
} from '../style'
import { AuthSchema } from '@validations'
import { Document } from '@apis'
import { useSelector } from 'react-redux'
import { store, Actions } from '@store'
import Empty from '@commons/empty'
import Svg from '@components/svg'
import Circle from '@components/circle'
const Registrations = () => {
  const { data: user } = useSelector((state: any) => state.user)
  const registrations = user?.documents?.filter(
    (document: any) => document?.type == 'Registration',
  )
  const [initialValues] = useState({
    type: 'License',
    documents: !!registrations?.length
      ? registrations?.map((registration: any) => {
          return {
            id: registration?.id,
            name: registration?.infos?.name,
            image: registration?.infos?.image,
            oldPath: registration?.infos?.image,
          }
        })
      : [],
  })
  const [loading, setLoading] = useState<boolean>(false)
  const submitHandler = async (values) => {
    setLoading(true)
    const payload = {
      type: values?.type,
      documents: values?.documents?.map((document: any) => {
        const item: any = {
          name: document?.name,
        }
        if (document?.id) {
          item.id = document?.id
        }
        if (document?.image?.base64) {
          item.image = {
            base64: document?.image?.base64,
            extension: document?.image?.extension,
          }
          item.oldPath = document.oldPath
        } else if (typeof document?.image == 'string') {
          item.image = document?.image
        }
        return item
      }),
    }
    await Document.createOrUpdate({
      data: payload,
    })
      .then((resp) => {
        store.dispatch(
          Actions.update('user', {
            ...user,
            documents: resp,
          }),
        )
      })
      .catch(() => {})
    setLoading(false)
  }

  return (
    <Formik
      initialValues={initialValues}
      onSubmit={submitHandler}
      enableReinitialize
      validationSchema={AuthSchema.licensesValidationSchema}
    >
      {({ handleSubmit, values, setFieldValue }) => {
        return (
          <Form onSubmit={handleSubmit}>
            <Column rowGap={20}>
              <Row styleRow="margin-top:-65px;margin-left:auto;">
                <Button
                  title="Add Document"
                  height={45}
                  leftComponent={<Svg svg="plus" color={'white'} />}
                  onClick={() => {
                    setFieldValue('documents', [
                      ...values?.documents,
                      {
                        name: '',
                        image: '',
                      },
                    ])
                  }}
                />
              </Row>
              {!!values?.documents?.length ? (
                <StyleGrid>
                  {values?.documents?.map((value, index: number) => {
                    return (
                      <Fragment key={index}>
                        <StyleGridItem>
                          {!value?.id && (
                            <Circle
                              bg="danger"
                              size={20}
                              styleCircle={styleCircle}
                              onClick={() => {
                                setFieldValue(
                                  'documents',
                                  values?.documents?.filter(
                                    (_, j) => index != j,
                                  ),
                                )
                              }}
                            >
                              <Svg svg="cross" color={'white'} size={14} />
                            </Circle>
                          )}
                          <Fields.Upload
                            varient="drag"
                            name={`documents[${index}][image]`}
                            placeholder="Upload Document Here"
                            styleWrapper={styleDocumentUploadWrapper}
                            size={180}
                            icon={'circleGallery'}
                          />
                          <Column rowGap={20} styleColumn="margin-top:20px;">
                            <Fields.Input
                              name={`documents[${index}][name]`}
                              placeholder="Document Name"
                              label="Document Name"
                            />
                          </Column>
                        </StyleGridItem>
                      </Fragment>
                    )
                  })}
                </StyleGrid>
              ) : (
                <Empty />
              )}
              <Column alignItems="flex-end">
                <Button
                  type="submit"
                  title="Submit"
                  height={40}
                  loading={loading}
                />
              </Column>
            </Column>
          </Form>
        )
      }}
    </Formik>
  )
}

export default Registrations
